import Vue from "vue";
import Router from "vue-router";
import auth from "@/commons/authService";
import commonFn from "@/commons/commonFunction";
import popupUtil from "@/commons/popupUtil";
import i18n from "@/i18ns/i18n";
import messageBox from '@/commons/messageBox';
import routerDemo from './routerDemo';
import routerDevice from './routerDevice';
import routerWebsite from './routerWebsite';
import routerAnonymous from './routerAnonymous';
import routerUser from './routerUser';
import routerAi from './routerAi';
import routerDataLake from './routerDataLake';
import routerReport from './routerReport';
import routerDeep from './routerDeep';
import routerEngine from './routerEngine';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/login",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/Login.vue"
        ),
      meta: {
        anonymous: true
      }
    },
    {
      path: "",
      component: () => import("@/layouts/MainLayout.vue"),
      meta: {
        // anonymous: true
      },
      children: [
        {
          //default page
          path: "/",
          redirect: "/dashboard",
          meta: {}
        },
        ...routerDevice,
        ...routerWebsite,
        ...routerDemo,
        ...routerAnonymous,
        ...routerUser,
        ...routerAi,
        ...routerDataLake,
        ...routerReport,
        ...routerDeep,
        ...routerEngine,
        {
          path: "/warring",
          name: "warring",
          component: () =>
            import(
              /*webpackChunkName:'pages'*/
              "@/pages/WarringDisplay.vue"
            ),
          meta: {
            anonymous: true
          }
        },
        {
          path: "/dashboard",
          name: "dashBoard",
          component: () => import(
            /*webpackChunkName:'dashboard'*/
            "@/views/dashboard/DashBoard.vue"),
          meta: {},
        },
        {
          path: "/machine-monitor",
          name: "MachineMonitor",
          component: () => import(
            /*webpackChunkName:'MachineMonitor'*/
            "@/views/dashboard/DashBoardMonitor.vue"),
          meta: {},
        },
        {
          path: "/dashboard/country3d",
          name: "country3d",
          component: () => import(
            /*webpackChunkName:'Country3d'*/
            "@/views/dashboard/Country3d.vue"),
          meta: {},
        },        
        {
          path: "/about",
          name: "about",
          component: () =>
            import(
              /*webpackChunkName:'about'*/
              "@/views/pages/About.vue"
            ),
          meta: {
            anonymous: true
          }
        },
      ]
    },
    {
      path: "/500",
      name: "500",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/404.vue"
        ),
      meta: {
        anonymous: true
      }
    },
    {
      // Redirect to 404 page, if no match found
      path: "/dev-login",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/DevLogin.vue"
        ),
      meta: {
        anonymous: true
      }
    },
    {
      // Redirect to 404 page, if no match found
      path: "*",
      component: () =>
        import(
          /*webpackChunkName:'pages'*/
          "@/pages/404.vue"
        ),
      meta: {
        anonymous: true
      }
    }
  ]
});

let routerOnReady = function () { };

let routerOnError = function (error) {
  // commonFunc.errorLogging(error);
};

router.onError(error => {
  const pattern = /Loading chunk (\S)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed && window._appConfig.showLoadChunkFail) {
    messageBox
      .showError(
        i18n.t("i18nSY.LoadChuckFail")
      )
      .then(res => {
        window.location.reload();
      });
  }
});

router.onReady(routerOnReady, routerOnError);

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach((to, from, next) => {
  //hide all popup
  popupUtil.hideAll();
  if (to.meta.anonymous || auth.isAuthenticated()) {  //bypass check authentication
    next();
  } else {
    commonFn.mask();
    // location.href = "/login"
    router.push("/login");
  }
});

export default router;
